var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoftwareDevelopment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450,
    height: 450,
    viewBox: "0 0 450 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11130_23646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.277 209.102L411.557 219.532L369.977 241.522L381.807 252.332C403.937 245.862 421.997 229.882 431.277 209.112V209.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.64 178L218.03 160.84L236.02 164.62L408.93 200.9L432.63 205.87C436.12 197 438.06 187.35 438.06 177.24C438.06 134.03 403.03 99 359.82 99H92.24C49.03 99 14 134.03 14 177.24C14 220.45 49.03 255.48 92.24 255.48H254.48L224.64 178Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.464 344.951L233.414 173.461L406.334 209.741L352.184 238.371L440.344 318.871L407.464 354.021L321.574 271.541L299.464 344.951Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11130_23646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 426.34,
    height: 255.02,
    fill: "white",
    transform: "translate(14 99)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareDevelopment);
export default __webpack_public_path__ + "static/media/software-development.fd76ed04b3522a2eafd0e138fe668f0e.svg";
export { ForwardRef as ReactComponent };